//src/services/actionPlanModels.ts
import { api } from "@/lib/apiClient";
import type {
  ActionPlanModel,
  ActionPlanModelCreateIn,
  ActionPlanModelDetail,
  ActionPlanModelItem,
  ActionPlanModelItemCreateIn,
  ActionPlanModelItemUpdateIn,
  ActionPlanModelUpdateIn,
} from "@/types/actionPlanModels";

export async function listActionPlanModels(params?: { q?: string; is_active?: boolean }) {
  return api.get<ActionPlanModel[]>("/action-plan-models", {
    params: {
      q: params?.q || undefined,
      is_active: typeof params?.is_active === "boolean" ? params.is_active : undefined,
    },
  });
}

export async function getActionPlanModel(id: string) {
  return api.get<ActionPlanModelDetail>(`/action-plan-models/${id}`);
}

export async function createActionPlanModel(payload: ActionPlanModelCreateIn) {
  return api.post<ActionPlanModel>("/action-plan-models", payload);
}

export async function updateActionPlanModel(id: string, payload: ActionPlanModelUpdateIn) {
  return api.put<ActionPlanModel>(`/action-plan-models/${id}`, payload);
}

export async function setActionPlanModelStatus(id: string, is_active: boolean) {
  return api.patch<ActionPlanModel>(`/action-plan-models/${id}/status`, { is_active });
}

export async function createActionPlanModelItem(modelId: string, payload: ActionPlanModelItemCreateIn) {
  return api.post<ActionPlanModelItem>(`/action-plan-models/${modelId}/items`, payload);
}

export async function updateActionPlanModelItem(itemId: string, payload: ActionPlanModelItemUpdateIn) {
  return api.put<ActionPlanModelItem>(`/action-plan-models/items/${itemId}`, payload);
}

export async function setActionPlanModelItemStatus(itemId: string, is_active: boolean) {
  return api.patch<ActionPlanModelItem>(`/action-plan-models/items/${itemId}/status`, { is_active });
}
